import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseuri, { chooseEnvironment } from '../../baseuri';
import { randomgen } from '../../utils/general-utils';
import { addToLoadingQueue, removeFromLoadingQueue } from './general';
import axios from 'axios';
import { message } from 'antd';

export const retrieveAdminUnremittedBalances = createAsyncThunk(
	'adminUnremittedBalances/retrieveAdminUnremittedBalances',
	async (params: any, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		try {
			const res = await baseuri.get('/admin/unremitted-balances', { params });
			dispatch(removeFromLoadingQueue(loadingId));
			return res.data.data;
		} catch (error) {
			dispatch(removeFromLoadingQueue(loadingId));
			throw error;
		}
	}
);

export const retrieveAdminUnremittedBalancesStatus = createAsyncThunk(
	'adminUnremittedBalances/retrieveAdminUnremittedBalancesStatus',
	async (_, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		try {
			const res = await axios.get(`${chooseEnvironment().base}/hooks/webhooks/unremitted-balances/status`, {
				headers: {
					'Content-Type': 'application/json',
					'migration-auth-key': 'cejine',
				},
			});
			console.log('response message from status',res.data.data)
			dispatch(removeFromLoadingQueue(loadingId));
			return res.data.data;
		} catch (error) {
			dispatch(removeFromLoadingQueue(loadingId));
			throw error;
		}
	}
);

export const resetAdminUnremittedBalances = createAsyncThunk(
	'adminUnremittedBalances/resetAdminUnremittedBalances',
	async (_, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		try {
			const res = await axios.post(`${chooseEnvironment().base}/hooks/webhooks/unremitted-balances/reset`, {}, {
				headers: {
					'Content-Type': 'application/json',
					'migration-auth-key': 'cejine',
				},
			});
			message.success(res?.data?.data?.message + ' ' + res?.data?.data?.recordsDeleted + ' records deleted');
			dispatch(removeFromLoadingQueue(loadingId));
			return res.data;
		} catch (error) {
			dispatch(removeFromLoadingQueue(loadingId));
			throw error;
		}
	}
);

export const runJobAdminUnremittedBalances = createAsyncThunk(
	'adminUnremittedBalances/runJobAdminUnremittedBalances',
	async (_, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		try {
			const res = await axios.post(`${chooseEnvironment().base}/hooks/webhooks/unremitted-balances/run-job`, {}, {
				headers: {
					'Content-Type': 'application/json',
					'migration-auth-key': 'cejine',
				},
			});
			message.success(res?.data?.message || 'Job started successfully');
			dispatch(removeFromLoadingQueue(loadingId));
			return res.data;
		} catch (error) {
			dispatch(removeFromLoadingQueue(loadingId));
			throw error;
		}
	}
);

const adminUnremittedBalancesRx = createSlice({
	name: 'adminUnremittedBalances',
	initialState: {
		unremittedBalances: {
			details: {
				itemsList: [],
				paginator: { currentPage: 1, itemCount: 0, perPage: 20 },
			},
			result: [],
		},
		jobStatus: null,
	},
	reducers: {},
	extraReducers: (builder) =>
		builder.addCase(retrieveAdminUnremittedBalances.fulfilled, (state, action) => {
			const store = state;
			store.unremittedBalances = action.payload;
		})
		.addCase(retrieveAdminUnremittedBalancesStatus.fulfilled, (state, action) => {
			state.jobStatus = action.payload;
		})
});

export default adminUnremittedBalancesRx.reducer;
